import * as Sentry from "@sentry/react"
import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { RouterProvider } from "@tanstack/react-router"
import { Toaster } from "react-hot-toast"

import { router } from "./router"
import { queryClient } from "./services/tanstackQuery/queryClient"

export function App() {
  return (
    // TODO: Error screen
    <Sentry.ErrorBoundary showDialog={false}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />

        <Toaster />

        <ReactQueryDevtools />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  )
}
